import { Link } from "react-scroll";
import data from "../../data/index.json";

export default function HeroSection() {
  const skillChips = (data?.skills || []).slice(0, 4).map((s) => s.title);
  const stats = [
    { label: "Certifications", value: "21x" },
    { label: "Certified", value: "8x AWS" },
    { label: "Terraform Expert", value: "Certified" },
  ];
  return (
    <section id="heroSection" className="hero-section">
      <div className="hero-section-content-box">
        <div className="hero-section-content">
          <div className="hero-badge">Open to impactful opportunities</div>
          <h1 className="hero-section-title">
            DevOps & <span className="gradient-text">Cloud Engineer</span>
          </h1>
          <p className="hero-section-description">
            I automate processes so teams can innovate without any friction.
            <br />
            Skilled in designing and implementing scalable, cost-effective, and
            secure cloud solutions.
          </p>
        </div>
        <div className="hero-cta-group">
          <Link to="MyPortfolio" smooth duration={500}>
            <button className="btn btn-primary">View Portfolio</button>
          </Link>
          <Link to="Newsletter" smooth duration={500}>
            <button className="btn btn-outline-primary">Subscribe</button>
          </Link>
        </div>
        {!!skillChips.length && (
          <ul className="skills-chips" aria-label="Key expertise areas">
            {skillChips.map((title) => (
              <li key={title} className="chip">
                {title}
              </li>
            ))}
          </ul>
        )}
        <div className="hero-stats" aria-label="Highlights">
          {stats.map((s) => (
            <div className="stat" key={s.label}>
              <div className="stat-value">{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="hero-section-img">
        <span className="decor-dot dd1" aria-hidden="true"></span>
        <span className="decor-dot dd2" aria-hidden="true"></span>
        <span className="decor-dot dd3" aria-hidden="true"></span>
        <img src="/primary-logo.png" alt="Tech With Manny logo" />
      </div>
    </section>
  );
}
